import "../stakeholderlayout.css"
export default function Integrated() {
  return (
    <div className="pillar-section">
      <div className="pillar-header">
        <span className="emoji">🧭</span>
        <h2>PILLAR 1 — INTEGRATED GROUP STRUCTURE</h2>
        <span className="subtitle">Specialisation with Governance Alignment</span>
      </div>

      <div className="pillar-content">
        <h3>Principle</h3>
        <p>
          Complex challenges require specialised expertise coordinated through shared governance 
          to ensure coherence, accountability, and long-term value.
        </p>

        <h3>Why It Matters</h3>
        <p>
          Fragmented service providers often produce disconnected solutions that fail to integrate 
          into institutional systems. A governance-led structure ensures that interventions reinforce 
          rather than undermine institutional stability.
        </p>

        <h3>How We Operationalise This</h3>
        <ul>
          <li>Independent subsidiaries with defined mandates</li>
          <li>Central governance oversight through Holdings</li>
          <li>Structured collaboration protocols</li>
          <li>Shared ethical and accountability frameworks</li>
        </ul>

        <h3>Stakeholder Benefit</h3>
        <ul>
          <li>Coordinated expertise without vendor conflict</li>
          <li>Institutional coherence across domains</li>
        </ul>

        {/* <div className="cta">
          <a href="/governance/institutional-model" className="learn-more">
            Click → Learn Governance Model
            <span className="arrow">👉</span>
          </a>
        </div> */}
      </div>
    </div>
  );
}